import React from 'react'
import { useTranslation } from 'react-i18next'
import { PageSection } from '../../../../shared/ui/PageSection'
import cls from './ContactSection.module.scss'

const ContactSection: React.FC = () => {
    const { t } = useTranslation()

    return (
        <PageSection
            title={t('contact.title')}
            style={{ backgroundColor: 'var(--bg-muted)' }}
        >
            <div className={cls.links}>
                <a
                    href="https://wa.me/996555309509"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`${cls.link} ${cls.whatsapp}`}
                    aria-label="WhatsApp"
                >
                    <img
                        src="https://cdn-icons-png.flaticon.com/256/185/185988.png"
                        alt=""
                        className={cls.icon}
                        loading="lazy"
                    />
                    WhatsApp
                </a>
                <a
                    href="https://t.me/vanlifekg"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`${cls.link} ${cls.telegram}`}
                    aria-label="Telegram"
                >
                    <img
                        src="https://cdn-icons-png.freepik.com/256/2111/2111646.png"
                        alt=""
                        className={cls.icon}
                        loading="lazy"
                    />
                    Telegram
                </a>
            </div>
            <p className={cls.phone}>+996 555 309 509</p>
        </PageSection>
    )
}

export default ContactSection
